/**
 * @module contactForm
 */
import {Button} from '../modules/button.js';

class ContactForm extends HTMLElement {
    constructor() {
        super();
        // Bind to this instance of the component
        this.handleAfterSwap = this.handleAfterSwap.bind(this);
        this.handleBeforeRequest = this.handleBeforeRequest.bind(this);
    }

    /** Called each time the element is added to the document. */
    connectedCallback() {
        const contactForm = this.querySelector('.js-contactForm');
        contactForm.addEventListener('htmx:afterSwap', this.handleAfterSwap);
        contactForm.addEventListener('htmx:beforeRequest', this.handleBeforeRequest);
    }

    /** Called each time the element is removed from the document. */
    disconnectedCallback() {
        const contactForm = this.querySelector('.js-contactForm');
        contactForm.removeEventListener('htmx:afterSwap', this.handleAfterSwap);
        contactForm.removeEventListener('htmx:beforeRequest', this.handleBeforeRequest);
    }

    handleAfterSwap() {
        document.dispatchEvent(new CustomEvent('lazy:initContent'));

        // Re-render Turnstile after DOM changes
        if (window.turnstile) {
            const turnstileElement = this.querySelector('.cf-turnstile');
            if (turnstileElement) {
                window.turnstile.render(turnstileElement);
            }
        }
    }

    handleBeforeRequest() {
        Button.addSpinner(this.querySelector('button[type=submit]'));
    }
}

customElements.define('ixdf-contact-form', ContactForm);
